import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api } from '../api/client'
import AuthCard, { authCardStyles as s } from './AuthCard'
import { ROUTES } from '../routes'
import {
  emailChangeApplied,
  emailChangeCancelled,
  translateAuthError
} from '../authMessages'

// Две публичные страницы по ссылкам из писем смены адреса: подтверждение
// приходит на новый адрес, отмена — на старый. Обе доступны без авторизации.
export default function EmailChangePage ({ action }) {
  const [params] = useSearchParams()
  const token = params.get('token')
  const [status, setStatus] = useState('working') // working | ok | error
  const [message, setMessage] = useState(null)

  useEffect(() => {
    if (!token) {
      setMessage(translateAuthError({ code: 'EMAIL_CHANGE_TOKEN_INVALID' }))
      setStatus('error')
      return
    }

    let cancelled = false
    const call = action === 'confirm'
      ? api.confirmEmailChange(token)
      : api.cancelEmailChange(token)

    call
      .then(data => {
        if (cancelled) return
        setMessage(action === 'confirm'
          ? emailChangeApplied(data.email)
          : emailChangeCancelled(data.email))
        setStatus('ok')
      })
      .catch(err => {
        if (cancelled) return
        setMessage(translateAuthError(err))
        setStatus('error')
      })

    return () => { cancelled = true }
  }, [action, token])

  return (
    <AuthCard>
      {status === 'working' && <div style={s.hint}>Проверяем ссылку…</div>}

      {status === 'ok' && (
        <div style={s.form}>
          <div style={s.notice} role='status'>{message}</div>
          {/* Полная перезагрузка, а не переход внутри SPA: адрес входа
              изменился, и состояние приложения нужно перечитать с сервера. */}
          <a style={s.link} href={ROUTES.INTEGRATIONS}>Перейти в платформу</a>
        </div>
      )}

      {status === 'error' && (
        <div style={s.form}>
          <div style={s.error} role='alert'>{message}</div>
          <Link style={s.link} to={ROUTES.LOGIN}>Вернуться к входу</Link>
        </div>
      )}
    </AuthCard>
  )
}
